import React from 'react';
import PropTypes from 'prop-types';

const ImagePreview = ({ fileName, url }) => <img src={url} alt={fileName || 'File preview'} />;

ImagePreview.propTypes = {
  fileName: PropTypes.string,
  url: PropTypes.string
};

export default ImagePreview;
